import { Component, OnInit ,ViewChild,TemplateRef} from '@angular/core';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import {
  CalendarEvent,
  CalendarMonthViewDay,
  CalendarView
} from "angular-calendar";
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.scss']
})


export class SchedulingComponent implements OnInit {

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  selectedDate: any;

   modalData: {
    action: string;
    event: CalendarEvent;
  };
/*-----------------------actions module not needed now---------------------- */
  //  actions: CalendarEventAction[] = [
  //   {
  //     label: '<i class="fas fa-fw fa-pencil-alt"></i>',
  //     a11yLabel: 'Edit',
  //     onClick: ({ event }: { event: CalendarEvent }): void => {
  //       this.handleEvent('Edited', event);
  //     },
  //   },
  //   {
  //     label: '<i class="fas fa-fw fa-trash-alt"></i>',
  //     a11yLabel: 'Delete',
  //     onClick: ({ event }: { event: CalendarEvent }): void => {
  //       this.events = this.events.filter((iEvent) => iEvent !== event);
  //       this.handleEvent('Deleted', event);
  //     },
  //   },
  // ];
/*-----------------------actions module not needed now---------------------- */

  events = [];

  scheduleP: FormGroup;

  refresh: Subject<any> = new Subject();

  submitted=false;

  error = "";

  timeSlots = [];

  selectedTimeSlots = [];

  receipts = [];

  modalRef: any;

  keyValue: any;

  recieptImage: any;

  imagePath: any;

  selectedFile: any;

  keydetail: any;

  adminEventData=[];

  completed_receipt_id: any;

  constructor(private sharedService: SharedService,private auth: AuthServiceService,private modalService: NgbModal, private local: LocalServiceService,private formBuilder: FormBuilder,private toastr: ToastrService,private router:Router) { }

  admins = [];

  selectedAdmin: any;

  selectDate: any;

  selectMonth: any;

  selectYear: any;

  imageUrl = environment.ImageUrl;

  phone: any;

  actions = [];

  activeDayIsOpen: boolean = false;

  selectedDays: any = [];

  selectedMonthViewDay: CalendarMonthViewDay<any>;

  dateSel:any;

  isUser:any=0;


  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.scheduleP = this.formBuilder.group({
        custNum: ['', [Validators.required]],
        custName: ['', [Validators.required]],
        time: ['',[Validators.required]],
        detail: ['', [Validators.required]],
      });

      let user = this.local.getUser();
      (user) ? this.isUser = 1 : this.isUser = 0;

      this.getAdmins();
      this.getTimeSlots();
      this.getCompleteCalendar();
      this.get_calendar_receipt();
      this.getActions();
      let date = new Date()
      this.dateSel = moment(date).format("MMM Do YYYY");
      this.getEventData();
    }
  }

    showRcpt(modal,data){
      this.recieptImage = '../../../../assets/images/pro.png';
      this.keyValue = undefined;
      this.phone = data.custNumber;
      this.completed_receipt_id = data.id;
      // console.log(`${this.completed_receipt_id}=-----------${this.phone}`);
      this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title',backdrop:'static'});
    }

  onImgError(event) { event.target.src = '../../../assets/images/default.png'; }


  onFileSelected(files)
  {
    console.log(files);
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }
    const reader = new FileReader();
    this.imagePath = files;
    this.selectedFile = <File>files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.recieptImage = reader.result;
    };

  }

  onUpload() {

    if (this.keyValue == undefined) {
      this.toastr.error('Please enter key Value');
      return;
    }

    if (isNaN(this.keyValue)) {
      this.toastr.error('Please enter numeric value')
      return;
    }

    const formData = new FormData();

    formData.append('image',this.selectedFile);
    formData.append('totalAmount',this.keyValue);
    formData.append('user_id',this.phone);
    formData.append('detail',this.keydetail);

    this.auth.addReciept(formData,this.phone).subscribe((response:any)=>{
      // console.log(response,'----------------');
      this.toastr.success(response.message);
      this.modalRef.close();

      setTimeout(() => {
      this.onStatus(this.completed_receipt_id,'2')
      }, 1000);

    },(e)=>{
      if(e.status == 400){
        this.toastr.error(e.error.message);
      }
    })
  }


  dayClicked(day: CalendarMonthViewDay): void {
    // console.log('===========>',events);
    this.selectedMonthViewDay = day;

    const selectedDateTime = this.selectedMonthViewDay.date.getTime();

    if(this.selectedDays.length == 0){
      // console.log(this.selectedDays);return;
      this.selectedDays.push(this.selectedMonthViewDay);
      day.cssClass = 'cal-day-selected';
      this.selectedMonthViewDay = day;
      console.log(this.selectedDays,"=========selectedDay");

    }else{
      console.log("===========>ia am here")
      const dateIndex = this.selectedDays.findIndex(
        (selectedDay) => selectedDay.date.getTime() === selectedDateTime
      );

      if (dateIndex != -1) {
        console.log("===========same data exists");
        delete this.selectedMonthViewDay.cssClass;
        this.selectedDays.splice(dateIndex, 1);
        console.log(this.selectedDays,"=========selectedDay");
      } else {
        console.log("===========some other data data exists");
        delete this.selectedDays[0].cssClass;

        this.selectedDays=[];

        this.selectedDays.push(this.selectedMonthViewDay);
        day.cssClass = 'cal-day-selected';
        this.selectedMonthViewDay = day;
        console.log(this.selectedDays,"=========selectedDay");
      }

    }

    this.selectDate = day.date.getDate();

    this.dateSel = moment(day.date).format("MMM Do YYYY");

    this.selectMonth = day.date.getMonth() + 1;

    this.selectYear = day.date.getFullYear();

    // console.log(`${this.selectDate} ,--- ${this.selectMonth} =--- ${this.selectYear}`); return;

    this.scheduleIn['time'].setValue(moment(day.date).format("MMM Do YYYY"));

    this.selectedDate = day.date.getTime() / 1000;

    //NOTE::get timeslots data when clicked on date else data according to current date

    this.getTimeSlots();

    //NOTE::get calendar data when clicked on date else data according to current date

    this.get_calendar_receipt();

    this.getEventData();

    // if (isSameMonth(day.date, this.viewDate)) {
    //   if (
    //     (isSameDay(this.viewDate, day.date) && this.activeDayIsOpen === true) ||
    //     day.events.length === 0
    //   ) {
    //     this.activeDayIsOpen = false;
    //   } else {
    //     this.activeDayIsOpen = true;
    //   }
    //   this.viewDate = day.date;
    // }
    // this.activeDayIsOpen = true;   //to show description bar
  }





  onChangeAdmin(checked, item) {
    item.active = !item.active;
    (checked)
      ? this.selectedTimeSlots.push(item.id)
      : this.selectedTimeSlots.splice(this.selectedTimeSlots.indexOf(item.id), 1);

    // console.log("+++++++++++", this.selectedTimeSlots);
  }



  handleEvent(action: string, event: CalendarEvent): void { this.modalData = { event, action }; }

  get scheduleIn()  { return this.scheduleP.controls;}

  scheduleSubmit() {
    this.submitted = true;
    if (this.scheduleP.invalid) {
      return;
    }

     if (this.selectedTimeSlots.length == 0) { this.toastr.error('Please select time slots'); return };

    if (this.selectedAdmin == null) { this.toastr.error('Please select any sub-admin'); return };

    const formData = new FormData();

    formData.append('custName', this.scheduleIn.custName.value);
    formData.append('custNumber', this.scheduleIn.custNum.value);
    formData.append('selectedDate', this.selectedDate);
    formData.append('details', this.scheduleIn.detail.value);
    formData.append('selectedTime', this.selectedTimeSlots.toString());
    formData.append('selectedAdminId', this.selectedAdmin);
    formData.append('year', this.selectYear);
    formData.append('month', this.selectMonth);
    formData.append('date', this.selectDate);

    this.auth.add_schedule(formData).subscribe((response: any) => {
      this.toastr.success('Schedule Added Successfully');
      setTimeout(() => {
      window.location.reload();
      }, 1000);
    }, (e) => {
      this.toastr.error(e.error.message);
      if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    })

  }

  getAdmins() {
    this.auth.getAllSubadmins().subscribe((response: any) => {
      let array2 = [36,37,39,40,41,42,28,60,61,55];  //hide these admins as per requirement
      this.admins = response.body.filter(e => !array2.includes(e.id));
      // console.log("+++++++=", response);
    })
  }

  getTimeSlots() {

    const formData = new FormData();
    if (this.selectedDate != null) {
      formData.append('timestamp', this.selectedDate);
      formData.append('year', this.selectYear);
      formData.append('month', this.selectMonth);
      formData.append('date', this.selectDate);
    }
    this.auth.getTimeSlots(formData).subscribe((response: any) => {
      this.timeSlots = response.body;
      // console.log("timeslots", response.body);
    }, (e) => {
      this.toastr.error(e.error.message);
      if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    })
  }

  getEventData() {

    const formData = new FormData();
    if (this.selectedDate != null) {
      formData.append('timestamp', this.selectedDate);
      formData.append('year', this.selectYear);
      formData.append('month', this.selectMonth);
      formData.append('date', this.selectDate);
    }
    this.auth.getEventData(formData).subscribe((response: any) => {
      this.adminEventData = response.body;
      // console.log("timeslots", response.body);
    }, (e) => {
      this.toastr.error(e.error.message);
      if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    })
  }


  getCompleteCalendar() {
    let arr = [];
    this.auth.get_all_calendar_data().subscribe((response: any) => {
      console.log("===============>ressponse",response.body);

      response.body.map((e) => {

        if (e.count <= 5) {
          e.color = colors.blue;
        } else if (e.count > 5 && e.count <= 10) {
          e.color = colors.yellow;
        } else if (e.count > 10) {
          e.color = colors.red;
        }

        let event_data = { 'start': new Date(e.startdate * 1000), 'end': new Date(e.enddate * 1000), 'title': e.title, color: e.color };

        arr.push(event_data);
      })

      this.events = arr;
      console.log(this.events, "++++");
      // console.log(response.body,"=============  ++++");
    })
  }

  onKeyUp(event: any){

    if(event.target.value  == undefined || event.target.value == ""){
      return;
    }else{
      let data = {'customerId':event.target.value};

      this.auth.get_user_detl(data).subscribe((response:any)=>{
        // console.log("==================>",response.body);return
         if(response.body.length != 0){
          this.scheduleIn['custName'].setValue(response.body[0].appUsersDatum.userName);
         }

      }, (e) => {
        this.toastr.error(e.error.message);
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      })
    }
 }

  get_calendar_receipt() {

    const formData = new FormData();
    if (this.selectedDate != null) {
      formData.append('timestamp', this.selectedDate);
      formData.append('year', this.selectYear);
      formData.append('month', this.selectMonth);
      formData.append('date', this.selectDate);
    }

    this.auth.get_all_calendar_receipts(formData).subscribe((response: any) => {
      this.receipts = response.body;
      console.log("recpt", response.body);
    })
  }

  onStatus(id, type) {
    switch (type) {
      case '1': {

        const formData1 = new FormData();
        formData1.append('slotId', id);
        formData1.append('buttonType', type);

        this.auth.schedule_button(formData1).subscribe((response: any) => {
          this.toastr.success(response.message);
          setTimeout(() => {
          window.location.reload();
          }, 1000);
          // console.log("response", response.body);

         }, (e) => {
            this.toastr.error(e.error.message);
            if (e.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
        })

        break;

      }
      case '2': {

        const formData2 = new FormData();
        formData2.append('slotId', id);
        formData2.append('buttonType', type);

        this.auth.schedule_button(formData2).subscribe((response: any) => {
          this.toastr.success(response.message);
          setTimeout(() => {
          window.location.reload();
          }, 1000);
          // console.log("response", response.body);

         }, (e) => {
              this.toastr.error(e.error.message);
              if (e.status == 401) {
                this.local.logout();
                this.router.navigate(['/admin']);
              }
          })

        break;

      }
      case '3': {

        const formData3 = new FormData();
        formData3.append('slotId', id);
        formData3.append('buttonType', type);

        this.auth.schedule_button(formData3).subscribe((response: any) => {
          this.toastr.success(response.message);
          setTimeout(() => {
          window.location.reload();
          }, 1000);
          // console.log("response", response.body);

         }, (e) => {
            this.toastr.error(e.error.message);
                  if (e.status == 401) {
                    this.local.logout();
                    this.router.navigate(['/admin']);
                  }
              })

        break;

      }
      case '4': {

        const formData4 = new FormData();
        formData4.append('slotId', id);
        formData4.append('buttonType', type);

        this.auth.schedule_button(formData4).subscribe((response: any) => {
          this.toastr.success(response.message);
          setTimeout(() => {
          window.location.reload();
          }, 1000);
          // console.log("response", response.body);

         }, (e) => {
            this.toastr.error(e.error.message);
            if (e.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
        })

        break;

      }
    }
  }



  getActions(){
    this.auth.get_Slots_actions().subscribe((response: any) => {
      this.actions = response.body;
      console.log("++", response.body);
    })
  }


  selectAdmin(id:number) {
    this.selectedAdmin = id;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  cancelData() { this.scheduleP.reset();}

}

  const colors: any = {
  red: {
    primary: "#ad2121",
    secondary: "#FAE3E3"
  },
  blue: {
    primary: "#1e90ff",
    secondary: "#D1E8FF"
  },
  yellow: {
    primary: "#e3bc08",
    secondary: "#FDF1BA"
  }
};
